import { BonusConditionValue } from '@synergy/models';
import { fields } from '@synergy/utils';

export interface BonusSettlementSupplierDetailEditFormValues {
    id: number;
    actualBonusValues: BonusConditionValue[];
    noteToCustomer: string;
}

export const BonusSettlementSupplierDetailEditFormValuesFieldNames =
    fields<BonusSettlementSupplierDetailEditFormValues>();
